import { fromJS } from 'immutable'
import {
  LEAVE_GENERTION_IMPORT_REQUEST,
  LEAVE_GENERTION_IMPORT_SUCCESS,
  LEAVE_GENERTION_IMPORT_FAILURE,
  LEAVE_GENERTION_IMPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_GENERTION_IMPORT_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_GENERTION_IMPORT_SUCCESS:
      return state
        .set('importResult', fromJS(action.payload.importResult))
        .set('isFetching', false)
    case LEAVE_GENERTION_IMPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_GENERTION_IMPORT_RESET:
      return state
        .delete('importResult')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-generation/leave-generation-import-reducer.js